import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class AbstractSideBar extends AbstractProvidedClass {
    tabContainer;
    tabs;

    init() {
        this.width = 300;
        this.x = this.p.width - this.width;
        this.y = 0;

        this.labelWidth = 36;
        this.labelHeight = 58;

        this.tabContainer = this.p.createDiv().parent('#p5canvas')
            .position(this.x - this.labelWidth, 0)
            .style('z-index', 1000);
    }

    resizeWindow() {
        this.x = this.p.width - this.width;
        this.tabContainer.position(this.x - this.labelWidth, 0);
        Object.values(this.tabs).map((tab) => tab.resizeWindow());
    }

    // The sidebar
    display() {
        this.p.noStroke();
        this.p.fill(255);
        this.p.stroke(100);
        this.p.strokeWeight(1);

        Object.keys(this.tabs).reverse().map((name, index) => this.displayTab(index));
        this.displayTab(Object.keys(this.tabs).findIndex((name) => name == this.openTab.name));
    }

    hovered() {
        if (this.p.mouseX < this.x - this.labelWidth) {
            return false;
        } else if (this.p.mouseX < this.x && this.p.mouseY > this.tabContainer.elt.clientHeight) {
            return false;
        }
        return true;
    }

    setTab(tab) {
        this.openTab.deactivate();
        this.openTab = this.tabs[tab];
        this.openTab.activate();
    }

    displayFirstTab() {
        this.p.beginShape();
        this.p.vertex(this.x - this.labelWidth, 1);
        this.p.vertex(this.x - this.labelWidth, 30);
        this.p.bezierVertex(this.x - this.labelWidth, 50, this.x, 50, this.x, 70);
        this.p.vertex(this.x, this.p.height + 1);
        this.p.vertex(this.p.width + 1, this.p.height + 1);
        this.p.vertex(this.p.width + 1, -1);
        this.p.vertex(this.x - this.labelWidth, -1);
        this.p.endShape();
    }

    displayTab(index) {
        if (index == 0) {
            this.displayFirstTab();
            return;
        }

        let verticalOffset = this.labelHeight * (index - 1);
        this.p.beginShape();
        this.p.vertex(this.x, -1);
        this.p.vertex(this.x, 30 + verticalOffset);
        this.p.bezierVertex(
            this.x,
            50 + verticalOffset,
            this.x - this.labelWidth,
            50 + verticalOffset,
            this.x - this.labelWidth,
            70 + verticalOffset
        )
        this.p.vertex(this.x - this.labelWidth, 90 + verticalOffset);
        this.p.bezierVertex(
            this.x - this.labelWidth,
            110 + verticalOffset,
            this.x,
            110 + verticalOffset,
            this.x,
            130 + verticalOffset
        );
        this.p.vertex(this.x, this.p.height + 1);
        this.p.vertex(this.p.width + 1, this.p.height + 1);
        this.p.vertex(this.p.width + 1, -1);
        this.p.vertex(this.x, -1);
        this.p.endShape();
    }
}
